// © 2025 COPYright LAHO – https://www.linkedin.com/in/laurens-holtkamp-7a686b2b/
import { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { deactivateNativePush } from '../lib/nativePush';
import { trackAnalyticsEvent } from '../services/analyticsService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authLoaded, setAuthLoaded] = useState(false); // ⬅️ Consistente naamgeving

  // Haal initiële gebruiker op
  useEffect(() => {
    const bootstrapUser = async (nextUser) => {
      if (!nextUser) return;

      const profileName = nextUser.user_metadata?.full_name || null;
      const { error: profileErr } = await supabase.rpc('ensure_user_profile', {
        p_name: profileName,
      });

      if (profileErr) {
        console.error('Fout bij aanmaken profiel na e-mailverificatie:', profileErr.message);
      }


    };

    const getUser = async () => {
      try {
        const { data: { user }, error } = await supabase.auth.getUser();
        if (!error) {
          setUser(user);
          await bootstrapUser(user);
        }
      } finally {
        setAuthLoaded(true);
      }
    };

    getUser().catch(() => {});

    // Luister naar login/logout veranderingen
    const { data: listener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        const nextUser = session?.user || null;
        setUser(nextUser);
        if (event === 'SIGNED_IN' && nextUser) {
          // Supabase holds its auth lock while notifying subscribers. Defer
          // requests so native email callbacks cannot deadlock.
          window.setTimeout(() => {
            bootstrapUser(nextUser).catch(() => {});
            trackAnalyticsEvent({
              eventName: 'login',
              user: nextUser,
              metadata: { provider: 'password' },
            });
          }, 0);
        }
      }
    );

    return () => {
      listener?.subscription?.unsubscribe();
    };
  }, []);

  const value = {
    user,
    authLoaded, // ⬅️ Vervangt 'loading'
    logout: async () => {
      // Invalidate the native token before the authenticated session disappears.
      await deactivateNativePush().catch(() => {});
      return supabase.auth.signOut();
    },
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

// ✅ Gebruik deze in je componenten
export const useUser = () => useContext(AuthContext);
